/*
 * CODE GENERATED AUTOMATICALLY WITH GraphQL Codegen
 * THIS FILE SHOULD NOT BE EDITED MANUALLY.
 */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

import * as Types from '@r-client/data/graphql-types';
export type IGetMarketingBannersQueryVariables = Types.Exact<{
  keys?: Types.InputMaybe<
    Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']
  >;
}>;

export type IGetMarketingBannersQuery = {
  __typename?: 'Query';
  marketingBanners: Array<{
    __typename?: 'MarketingBannersBanner';
    id: string;
    key: string;
    slides: Array<{
      __typename?: 'MarketingBannersSlide';
      id: string;
      name: string;
      fieldValues: Array<{
        __typename?: 'MarketingBannersSlideFieldValue';
        id: string;
        textValue?: string | null | undefined;
        assetImageUrl?: string | null | undefined;
        assetImageUrl2x?: string | null | undefined;
        assetVideoUrl?: string | null | undefined;
        field: {
          __typename?: 'MarketingBannersBannerField';
          key: string;
          fieldType: Types.IMarketingBannersFieldTypeEnum;
        };
      }>;
    }>;
  }>;
};

export const GetMarketingBannersDocument = gql`
  query GetMarketingBanners($keys: [String!]) {
    marketingBanners(keys: $keys) {
      id
      key
      slides {
        id
        name
        fieldValues {
          id
          textValue
          field {
            key
            fieldType
          }
          assetImageUrl(
            extension: webp
            resize: { width: 510, height: 340, type: fit }
          )
          assetImageUrl2x: assetImageUrl(
            extension: webp
            resize: { width: 1020, height: 680, type: fit }
          )
          assetVideoUrl
        }
      }
    }
  }
`;
export type GetMarketingBannersQueryResult = Apollo.QueryResult<
  IGetMarketingBannersQuery,
  IGetMarketingBannersQueryVariables
>;
